jQuery(document).ready(function($) {

	// Toggle the login form on checkout
	$('.login-input input').on('click', function() {
		if( 'show' === $(this).val() )  {
			$('.checkout-login-form').slideDown({
				start: function () {
				  $(this).css({
					display: "flex"
				  })
				}
			});			  
		}
		else {
			$('.checkout-login-form').slideUp({
				start: function () {
				  $(this).css({
					display: "flex"
				  })
				}
			});
		}
	});
});